<template>
    <ur-modal ref="modal">
    <div><ur-box title="공지사항">
         <div> <div class="flex-item" label="ReadOnly">
        <ur-text-area v-model="notice1" readonly />
    </div> </div>
    </ur-box>
    <div align="right">하루동안 보지 않기</div></div>

    </ur-modal>
</template>
<script>
export default {
    name: 'PGE_AIN_00001',

    data() { return {
        noticeTitle1: '공지사항 타이틀',
        notice1:'관리자가 작성한 공지 내용이 표출됨'
    }},
    methods: {
        open() {
            this.$refs['modal'].open();
        },
        close() {
            this.$refs['modal'].close();
        }
    }
}
</script>
